import { HeaderLabelChipStyle } from '@tableau/catalog-ui-temp';
import React from 'react';

import { SiteUrlsProps } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { LabelWrapper } from '~src/catalog/CatalogLabelsHookHelper';
import {
  EditPublishedConnectionEntityAction,
} from '~src/publishedConnection/entityActions/EditPublishedConnectionEntityAction';
import { isPublishedConnectionTableInfo } from '~src/publishedConnectionTable/resources/PublishedConnectionTables';
import { IPublishedConnectionTableActions } from '~src/publishedConnectionTable/serverApi/types/IPublishedConnectionTableActions';
import { ItemDescription } from '~src/spacesPlatform/components/header/HeaderItemDescription';
import {
  ModifiedDateMetadata,
  OwnerMetadata,
  PublishedConnectionPolicyMetaData,
  VirtualConnectionTableExtractStatusMetadata,
} from '~src/spacesPlatform/components/header/HeaderMetadataRow';
import { ActionsMenuIcon, FavoriteToggleWithCountsIcon } from '~src/spacesPlatform/components/header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '~src/spacesPlatform/components/header/SpaceHeader';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';
import { TagsMetadata } from '~src/tags/components/header/TagsMetadata';
export interface PublishedConnectionTableSpaceHeaderProps extends SiteUrlsProps {
  readonly itemInfo: ISpaceItemDetailInfo<'virtualConnectionTable'>;
  readonly availableActions: IPublishedConnectionTableActions;
  readonly openDetail: () => void;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
}

export function PublishedConnectionTableSpaceHeader(props: PublishedConnectionTableSpaceHeaderProps): JSX.Element {
  const tagUrl = React.useCallback((tag: string) => props.urls.virtualConnectionTablesWithTagUrl(tag), [props.urls]);

  return (
    <ConnectedSpaceHeader
      item={props.itemInfo}
      availableActions={{ ...props.availableActions }}
      detailIcons={
        <React.Fragment>
          {FavoriteToggleWithCountsIcon({
            item: props.itemInfo,
            addToFavorites: props.addToFavorites,
            removeFromFavorites: props.removeFromFavorites,
          })}
          {ActionsMenuIcon(props.itemInfo)}
        </React.Fragment>
      }
      metadataElement={
        <React.Fragment>
          {OwnerMetadata(props.itemInfo.owner, props.urls)}
          {ModifiedDateMetadata(props.itemInfo.updatedAt)}
          {VirtualConnectionTableExtractStatusMetadata(props.itemInfo.hasExtracts)}
          {isPublishedConnectionTableInfo(props.itemInfo) && PublishedConnectionPolicyMetaData(props.itemInfo)}
          <div style={{marginLeft: '24px'}}>
            <LabelWrapper itemInfo={props.itemInfo} isEager={true} kind={'chip'}
              wrapper={(e) =><HeaderLabelChipStyle>{e}</HeaderLabelChipStyle>} />
          </div>
        </React.Fragment>
      }
      spotlightActions={[EditPublishedConnectionEntityAction]}
      descriptionElement={<ItemDescription item={props.itemInfo}/>}
      bottomElement={TagsMetadata({ itemInfo: props.itemInfo, tagUrl })}
    />
  );
}
